import { render, staticRenderFns } from "./oftenFlowList.vue?vue&type=template&id=8885e9d8&scoped=true&"
import script from "./oftenFlowList.vue?vue&type=script&lang=js&"
export * from "./oftenFlowList.vue?vue&type=script&lang=js&"
import style0 from "./oftenFlowList.vue?vue&type=style&index=0&id=8885e9d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8885e9d8",
  null
  
)

export default component.exports